import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'id',
  months: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
  weekdays: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
  weekdaysMin: ['Mi', 'Sn', 'Sl', 'Rb', 'Km', 'Ju', 'Sb'],
  weekdaysShort: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
  formats: {
    LT: 'HH.mm',
    LTS: 'HH.mm.ss',
    lt: 'h.mm A',
    lts: 'h.mm.ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH.mm',
    'LLL-Y': 'D MMMM HH.mm',
    LLLL: 'dddd, D MMMM YYYY HH.mm',
    'LLLL-Y': 'dddd, D MMMM HH.mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h.mm A',
    'lll-Y': 'D MMM h.mm A',
    llll: 'ddd, D MMM YYYY h.mm A',
    'llll-Y': 'ddd, D MMM h.mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH.mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH.mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s thn lalu' },
    M: { other: '%s bln lalu' },
    w: { other: '%s mgg lalu' },
    d: { other: '%s h lalu' },
    h: { other: '%s jam lalu' },
    m: { other: '%s mnt lalu' },
    s: { other: '%s dtk lalu' },
  },
  future: {
    y: { other: 'dlm %s thn' },
    M: { other: 'dlm %s bln' },
    w: { other: 'dlm %s mgg' },
    d: { other: 'dlm %s h' },
    h: { other: 'dlm %s jam' },
    m: { other: 'dlm %s mnt' },
    s: { other: 'dlm %s dtk' },
  },
  pastLong: {
    y: { other: '%s tahun yang lalu' },
    M: { other: '%s bulan yang lalu' },
    w: { other: '%s minggu yang lalu' },
    d: { other: '%s hari yang lalu' },
    h: { other: '%s jam yang lalu' },
    m: { other: '%s menit yang lalu' },
    s: { other: '%s detik yang lalu' },
  },
  futureLong: {
    y: { other: 'dalam %s tahun' },
    M: { other: 'dalam %s bulan' },
    w: { other: 'dalam %s minggu' },
    d: { other: 'dalam %s hari' },
    h: { other: 'dalam %s jam' },
    m: { other: 'dalam %s menit' },
    s: { other: 'dalam %s detik' },
  },
  abbr: {
    y: { other: '%s thn' },
    M: { other: '%s bln' },
    w: { other: '%s mgg' },
    d: { other: '%s h' },
    h: { other: '%s j' },
    m: { other: '%s mnt' },
    s: { other: '%s dtk' },
  },
  full: {
    y: { other: '%s tahun' },
    M: { other: '%s bulan' },
    w: { other: '%s minggu' },
    d: { other: '%s hari' },
    h: { other: '%s jam' },
    m: { other: '%s menit' },
    s: { other: '%s detik' },
  },
  justNow: 'Baru saja',
  yesterday: 'Kemarin',
  today: 'Hari ini',
  tomorrow: 'Besok',
  weekStart: 0,
  timeRange: '%$1s—%$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h.mm A': 'HH.mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH.mm', end: 'D MMM YYYY HH.mm' },
    mt: { start: 'D MMM HH.mm', end: 'D MMM HH.mm' },
    dt: { start: 'D MMM HH.mm', end: 'D MMM HH.mm' },
    t: { start: 'HH.mm', end: 'HH.mm' },
    'yt+to': { start: 'D MMM YYYY HH.mm', end: 'D MMM YYYY HH.mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH.mm', end: 'D MMM HH.mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH.mm', end: 'D MMM HH.mm ([GMT]Z)' },
    't+to': { start: 'HH.mm', end: 'HH.mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'id';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
